import { createFileRoute, redirect } from "@tanstack/react-router";
import { queries } from "@theprelude/core";
import { hasFeatures } from "@/components/flag/flag";
export const Route = createFileRoute("/_app/home")({
  beforeLoad: async ({ context }) => {
    const authConfig = await context.auth.getAuthConfig();
    const account = await context.queryClient.ensureQueryData(
      queries.iam.getAccount(authConfig),
    );

    if (hasFeatures(account, ["policy_evaluator"])) {
      throw redirect({
        to: "/control-monitor",
        search: (prev) => prev,
        params: (prev) => prev,
      });
    } else if (hasFeatures(account, ["detect"])) {
      throw redirect({
        to: "/dashboard",
        search: (prev) => prev,
        params: (prev) => prev,
      });
    }
    throw redirect({
      to: "/account",
      search: (prev) => prev,
      params: (prev) => prev,
    });
  },
});
